import React from 'react';
import { Chip } from '@mui/material';

interface BadgeProps {
  value: number;
  label?: string;
  showValue?: boolean;
}

const Badge: React.FC<BadgeProps> = ({ value, label, showValue = true }) => {
  const getColor = (rating: number) => {
    if (rating < 5) return 'error';
    if (rating < 7) return 'warning';
    return 'success';
  };

  const getBadgeText = () => {
    if (showValue) {
      return label ? `${label}: ${value}` : value.toString();
    }
    return label || '';
  };

  return (
    <Chip
      label={getBadgeText()}
      color={getColor(value)}
      variant="outlined"
      size="small"
    />
  );
};

export default Badge;
